var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"responsibility"}},[_c('navigation-sub',{attrs:{"list":[
      {
        title: _vm.$t('menuSustainability.ethicalManagement'),
        anchor: _vm.$t('conduct.title')
      },
      {
        title: _vm.$t('menuSustainability.compliance'),
        anchor: _vm.$t('compliance.declaration.title')
      },
      {
        title: _vm.$t('menuSustainability.sustainable'),
        anchor: _vm.$t('sustainable.declaration.title')
      },
      {
        title: _vm.$t('menuSustainability.informationProtection'),
        anchor: _vm.$t('informationProtection.compliance.title')
      }
    ]}}),_c('Ethical'),_c('Compliance'),_c('Sustainable'),_c('InformationProtection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }